<script>
export default {
  name: "CouponInvalid",
  computed:{
    couponInvalid() {
      return this.$store.getters.orderSystem.couponInvalid;
    }
  },
  methods: {
    closeInvalid() {
      console.log("Invalid coupon closed")
      this.$store.commit("clearCouponInvalid")
    }
  }
}
</script>

<template>
<v-alert v-if="couponInvalid"  type="error" close-label="cerrar">
  <span>Cupón Invalido</span>
  <template v-slot:close>
    <v-btn icon  @click="closeInvalid"><v-icon>close</v-icon></v-btn>
  </template>
</v-alert>
</template>

<style scoped>

</style>
